export default "__VITE_ASSET__DkjupI5N__"